var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-card"},[_c('div',{staticClass:"wrapper-img",style:({ backgroundColor: _vm.bgColor })},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.title + '.png'}})]),_vm._v(" "),_c('div',{staticClass:"text_frame"},[_c('div',{staticClass:"text_frame__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }